import React from 'react';
import {BlockComp} from 'core/components/blockComp/blockComp';
import * as PartyFeatureForms from 'party/component/partyFeatures';
import {addSeparator} from "core/common/utils/arrayUtils";
import {MdDivider} from "core/components/blockComp/blockComp";
import {observer} from "mobx-react";
import {Party} from "party/partyDomain";
import {ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {FormProps} from "core/form/formUtils";



interface PartyFeatureListProps {
  partyObject: Party;
  rootObject: Party;
  entities: ObservableMap<MdEntity>;
}

@observer
export default class PartyFeatureList extends React.Component<PartyFeatureListProps, undefined> {


  render() {

    const {partyObject, rootObject, entities} = this.props;


    return (partyObject.features && partyObject.features.length) ? (
      <BlockComp  noPadding={true} style={{display: 'flex', flexDirection: 'column'}} >

        {
          addSeparator( partyObject.features.map((feature, index) => {
            let PartyFeatureForm: React.ComponentClass<FormProps<any, Party>> = PartyFeatureForms[feature.featureType + 'Form'];
            return <PartyFeatureForm dataObject={feature} rootObject={partyObject} key={index}
                              entities={entities} entity={entities.get('PartyFeature')}
                              index={index}/>
          }), <MdDivider inset/>)
        }

      </BlockComp>
    ) :null;
  }
}



// WEBPACK FOOTER //
// ./src/party/component/partyFeatureList.tsx